import {
    useEffect,
    useCallback
} from 'react';

import {
    useIsExporting
} from '../../../hooks/useExport.js';

import {
    useGetDashboardType,
    DashboardTypes
} from './useGetDashboardType.js';

import {
    useLoadLandscapeListeningQuery
} from './useListeningQueryPersistence.js';

const SavedSearchTourConfig = {
    tourId: 'listening-saved-search-tour',
    closeButtonText: 'Got it!',
    startDelay: 0,
    steps: [
        {
            element: '.title-dropdown.dropdown-menu li:first-child a[data-value="__edit"]',
            content: 'Edit your search here.',
            placement: 'right',
            bodyClass: 'listening-tour'
        }
    ],
    onStart: _.constant(() => {
        // expand the switcher dropdown
        $('.x-primary-navigation-title .dropdown .title-dropdown').addClass('tlw-block');
    }),
    onEnd: _.constant(() => {
        // close the switcher dropdown
        $('.x-primary-navigation-title .dropdown .title-dropdown').removeClass('tlw-block');
    })
};

const InstantSearchTourConfig = {
    tourId: 'listening-instant-search-tour',
    closeButtonText: 'Got it!',
    startDelay: 0,
    steps: [
        {
            element: '#edit-search-button',
            content: 'Edit to refine your results.',
            placement: 'bottom',
            bodyClass: 'listening-tour'
        }
    ]
};

function useShowTour(tourOptions) {
    const tourId = tourOptions.tourId;

    return useCallback(() => {
        RivalIQ.execute('tour:start', tourOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tourId]);
}


export function useShowEditSavedSearchTour(listeningQueryId, canShowTour) {

    const {data: listeningQuery} = useLoadLandscapeListeningQuery(listeningQueryId);
    const showSavedSearchTour = useShowTour(SavedSearchTourConfig);

    if (listeningQuery?.isSampleTopic) {
        canShowTour = false;
    }

    const dashboardType = useGetDashboardType();
    const isExporting = useIsExporting();

    useEffect(() => {
        if (dashboardType === DashboardTypes.SAVED_SEARCH && canShowTour && !isExporting) {
            showSavedSearchTour();
        }
    }, [canShowTour, dashboardType, isExporting, showSavedSearchTour]);
}


export function useShowInstantSearchTour(canShowTour) {

    const showInstantSearchTour = useShowTour(InstantSearchTourConfig);

    const isExporting = useIsExporting();
    const dashboardType = useGetDashboardType();

    useEffect(() => {
        if (dashboardType === DashboardTypes.INSTANT_SEARCH && canShowTour && !isExporting) {
            showInstantSearchTour();
        }
    }, [dashboardType, canShowTour, isExporting, showInstantSearchTour]);
}
